<template>
  <v-sheet class="pa-4">
    <v-row dense>
      <v-col cols="12">
        <v-btn
          class="mr-4 float-right"
          outlined
          color="indigo"
          @click.stop="create"
        >
          <v-icon left>mdi-plus</v-icon>
          {{ $t('ITEM.ADD') }} {{ $t('DEVICES.ITEM') }}
        </v-btn>
      </v-col>
      <v-col cols="12">
        <device-list
          :type="type"
          :meta="meta"
          :devices="devices"
          :options.sync="options"
          @show="show"
        />
      </v-col>
    </v-row>

    <v-dialog v-if="dialogCreate" v-model="dialogCreate" max-width="500px">
      <v-card flat dense>
        <v-card-title>
          {{ $t('DEVICES.LIST_HEADER') }}

          <v-spacer />

          <v-btn icon @click="dialogCreate = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-subtitle class="pb-3">
          {{ $t('DEVICES.LIST_SUBHEADER') }}
        </v-card-subtitle>

        <v-card-text>
          <device-types-list v-model="selected" />
        </v-card-text>

        <v-card-actions>
          <v-btn
            outlined
            depressed
            large
            color="grey"
            @click.prevent="dialogCreate = !dialogCreate"
          >
            {{ $t('BUTTON.CANCEL') }}
          </v-btn>
          <v-spacer />
          <v-btn
            :disabled="selected === undefined"
            depressed
            color="primary"
            large
            @click.prevent="createDevice()"
          >
            {{ $t('BUTTON.CREATE') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-if="dialog"
      v-model="dialog"
      persistent
      width="unset"
      max-width="600"
    >
      <component
        :is="component.name"
        v-bind="component.data"
        @created="cancelDialogAndRefresh"
        @updated="cancelDialogAndRefresh"
        @cancel="cancelDialog"
      />
    </v-dialog>
  </v-sheet>
</template>

<script>
import errors from '@/modules/_global/mixins/errors';
import DataOptions from '@/modules/_global/classes/DataOptions';
import i18nRefreshData from '@/modules/_global/mixins/i18nRefreshData';
import { DevicesService } from '@/services/devices.service';
import { PERSON } from '@/modules/devices/components/DeviceList';
import { types } from '@/modules/persons/components/Devices/DeviceTypesList';

export default {
  name: 'Device',

  components: {
    DeviceList: () => import('@/modules/devices/components/DeviceList'),
    DeviceTypesList: () =>
      import('@/modules/persons/components/Devices/DeviceTypesList'),
    CreateDevice: () =>
      import('@/modules/persons/components/Devices/CreateDevice'),
    SelectDevice: () =>
      import('@/modules/persons/components/Devices/SelectDevice'),
    EditDevice: () => import('@/modules/devices/Device/components/EditDevice')
  },

  mixins: [errors, i18nRefreshData],

  props: {
    personId: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      type: PERSON,
      devices: [],
      meta: {
        total: 0
      },
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ['to'],
        sortDesc: [true],
        groupBy: [],
        groupDesc: [],
        mustSort: false,
        multiSort: false
      },
      error: null,
      dialog: false,
      component: null,
      dialogCreate: false,
      selected: types.WAREHOUSE
    };
  },

  computed: {
    preparedOptions() {
      return DataOptions.createFromObject(this.options).toBackendFormat();
    },

    createDeviceComponent() {
      if (this.selected === types.WAREHOUSE) {
        return 'SelectDevice';
      }

      if (this.selected === types.PERSON) {
        return 'CreateDevice';
      }

      return null;
    }
  },

  watch: {
    options: {
      deep: true,
      immediate: true,
      handler() {
        this.refreshData();
      }
    }
  },

  methods: {
    refreshData() {
      this.getDevices();
    },

    getDevices() {
      return DevicesService.getList({
        ...this.preparedOptions,
        person: this.personId
      })
        .then(({ data: { meta, data } }) => {
          this.meta = meta;
          this.devices = data;
        })
        .catch(error => {
          this.error = error;
        });
    },

    create() {
      this.dialogCreate = true;
    },

    createDevice() {
      this.dialogCreate = false;
      this.dialog = true;
      this.component = {
        name: this.createDeviceComponent,
        data: {
          personId: this.personId
        }
      };
    },

    show(device) {
      this.dialog = true;
      this.component = {
        name: 'EditDevice',
        data: {
          id: device.id,
          showDeviceDetails: true,
          showCustomerDetails: true
        }
      };
    },

    cancelDialog() {
      this.dialog = false;
      this.component = null;
    },

    cancelDialogAndRefresh() {
      this.refreshData();
      this.cancelDialog();
    }
  }
};
</script>
